<template>
  <div>
    <el-table id="codingLargeStatPtType" :data="dashboardData.length ? dashboardData[0].largeStats[1].data : []" empty-text="No Patient Types Available" :fit="true"
      :height="isModal ? null : '300'" show-summary :summary-method="getSummary">
      <el-table-column prop="patientType" label="Patient Type" sortable>
      </el-table-column>
      <el-table-column type="expand" id="patientTypeHeaderExpand">
        <template slot-scope=" props">
          <el-table :data="patientTypeGetDrillDownForRow(props.row)" empty-text="No Data Available" :fit="true">
            <el-table-column prop="consultant" label="Consultant" sortable>
              <template slot-scope="scope">
                <avatar :fullname="scope.row.consultantName" :image="scope.row.photo" :size="30"></avatar>
              </template>
            </el-table-column>
            <!-- <el-table-column prop="totalCharges" label="Total Charges" sortable :formatter="moneyFormatter">
            </el-table-column> -->
            <el-table-column prop="totalRecords" label="Total Records" sortable>
            </el-table-column>
          </el-table>
        </template>
      </el-table-column>
      <el-table-column prop="patientTypeTotal" label="Total Records" sortable>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  import avatar from '@/components/avatar'
  import money from '@/mixins/money'

  export default {
    props: ['dashboardData'],
    mixins: [money],
    components: {
      avatar
    },
    data: function () {
      return {
      }
    },
    name: 'PatientTypes',
    methods: {
      patientTypeGetDrillDownForRow(row) {
        return row.consultants.length ? row.consultants : []
      },
      moneyFormatter(row, column) {
        return `$${this.formatMoney(row.totalCharges || row.consultantTotalCharges)}`
      },
      totalSummary(column, data) {
        let response = data.reduce((total, curr) => {
          const value = Number(curr[column])
          if (!isNaN(value)) {
            return total + value
          } else {
            return total
          }
        }, 0)

        return response
      },
      getSummary(param) {
        const patientTypeTotal = this.totalSummary('patientTypeTotal', param.data)
        return [null, null, patientTypeTotal]
      }
    },
    created: function () {
    },
    computed: {
      isModal() {
        return this.$parent.modal
      }
    }
  }
</script>
